import { ContactForm } from '@/components/ui/forms/form-contact/ContactForm';

export const ContactFormBlock = ({ root }) => {
  return <ContactForm locale={root?.meta?.language} />;
};
